import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { FAQS } from "../../data/mock";

export const Faq = () => {
  return (
    <section id="faq" className="py-16 sm:py-24" data-testid="faq-section">
      <div className="mx-auto max-w-3xl px-4">
        <p className="text-center text-xs uppercase tracking-[0.3em] text-[#2f7fff] mb-4">FAQ</p>
        <h2 className="font-heading text-center text-3xl sm:text-4xl uppercase tracking-tight text-white mb-12">
          Questions, <span className="text-gradient-blue">answered.</span>
        </h2>

        <Accordion type="single" collapsible defaultValue="faq-0" className="space-y-4">
          {FAQS.map((faq, i) => (
            <AccordionItem
              key={faq.question}
              value={`faq-${i}`}
              className="rounded-2xl border border-white/10 bg-[#0b0d10] px-6 data-[state=open]:border-[#2f7fff]/40"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left text-white hover:no-underline" data-testid={`faq-trigger-${i}`}>
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-zinc-400 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
